export const registerCustomStyleTraits = (editor) => {
  editor.Styles.addType(
    'margin-custom',
    createBoxModelTrait(editor, {
      property: 'margin',
      label: 'Margin',
    }),
  );

  editor.Styles.addType(
    'padding-custom',
    createBoxModelTrait(editor, {
      property: 'padding',
      label: 'Padding',
    }),
  );

  editor.Styles.addType(
    'border-radius-custom',
    createBoxModelTrait(editor, {
      property: 'border-radius',
      name: 'Rounded Corners',
      parts: ['top-left', 'top-right', 'bottom-right', 'bottom-left'],
      partLabels: ['Top Left', 'Top Right', 'Bottom Right', 'Bottom Left'],
    }),
  );
};

function createBoxModelTrait(
  editor,
  {
    property = 'margin',
    name = 'Margin',
    units = ['px', '%', 'rem', 'em', 'vw', 'vh'],
    parts = ['top', 'right', 'bottom', 'left'],
    partLabels = ['Top', 'Right', 'Bottom', 'Left'],
  },
) {
  return {
    extend: 'composite',
    create({ property: traitProp }) {
      const eventListeners = []; // To cleanup
      const mainWrapper = document.createElement('div');
      Object.assign(mainWrapper.style, {
        width: '100%',
        padding: '2px',
        background: '#fff',
      });

      const wrapper = document.createElement('div');
      Object.assign(wrapper.style, {
        width: '100%',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '16px',
        background: '#fff',
        marginBottom: '10px',
      });

      const sideInputs = {};
      const bind = (el, evt, fn) => {
        el.addEventListener(evt, fn);
        eventListeners.push(() => el.removeEventListener(evt, fn));
      };

      const createLabeledInput = (labelText, id) => {
        const wrapper = document.createElement('div');
        wrapper.style.cssText =
          'display: flex; flex-direction: column; position: relative;';

        const label = document.createElement('label');
        label.textContent = labelText;
        label.style.cssText = 'font-size: 10px; margin-bottom: 2px;';

        const inputRow = document.createElement('div');
        inputRow.style.cssText =
          'display: flex; align-items: center; position: relative;';

        const input = document.createElement('input');
        input.type = 'number';
        input.className = 'gjs-field';
        Object.assign(input.style, {
          margin: '0px',
          padding: '0.7em 1.4em',
          border: '1px solid #ccc',
          borderRadius: '4px 0 0 4px',
          flex: 1,
          height: '31px',
          appearance: 'auto',
        });

        const unitDisplay = document.createElement('div');
        unitDisplay.textContent = 'px';
        Object.assign(unitDisplay.style, {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '31px',
          width: '35px',
          border: '1px solid #ccc',
          borderLeft: 'none',
          padding: '0.7em',
          cursor: 'pointer',
          borderRadius: '0 4px 4px 0',
          userSelect: 'none',
          backgroundColor: '#f5f5f5',
        });

        const unitDropdown = document.createElement('div');
        Object.assign(unitDropdown.style, {
          position: 'absolute',
          minWidth: '35px',
          top: '100%',
          right: 0,
          zIndex: 1000,
          backgroundColor: 'white',
          color: 'black',
          border: '1px solid #ccc',
          display: 'none',
        });

        units.forEach((unit) => {
          const option = document.createElement('div');
          option.textContent = unit;
          option.style.textAlign = 'center';
          option.style.padding = '8px 2px';
          option.style.cursor = 'pointer';
          option.style.backgroundColor = '#444';
          option.style.color = '#ddd';

          const listener = () => {
            unitDisplay.textContent = unit;
            unitDropdown.style.display = 'none';
            unitDisplay.dispatchEvent(new Event('change'));
          };
          const MouseEnter = () => {
            option.style.backgroundColor = '#007bff';
            option.style.color = '#fff';
          };
          const MouseLeave = () => {
            option.style.backgroundColor = '#444';
            option.style.color = '#ddd';
          };
          bind(option, 'mouseenter', MouseEnter);
          bind(option, 'mouseleave', MouseLeave);
          bind(option, 'click', listener);
          unitDropdown.appendChild(option);
        });

        const toggleDropdown = (e) => {
          e.stopPropagation();
          const isVisible = unitDropdown.style.display === 'block';
          unitDropdown.style.display = isVisible ? 'none' : 'block';

          if (!isVisible) {
            const rect = unitDisplay.getBoundingClientRect();
            const sectorEl = unitDisplay.closest('.gjs-sm-sector');
            const dropdownHeight = unitDropdown.offsetHeight;
            let spaceBelow, spaceAbove;

            if (sectorEl) {
              const sectorContainer = sectorEl.getBoundingClientRect();
              spaceBelow = sectorContainer.bottom - rect.bottom;
              spaceAbove = rect.top;
            } else {
              // fallback to viewport
              spaceBelow = window.innerHeight - rect.bottom;
              spaceAbove = rect.top;
            }

            if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
              unitDropdown.style.top = 'auto';
              unitDropdown.style.bottom = '100%';
            } else {
              unitDropdown.style.top = '100%';
              unitDropdown.style.bottom = 'auto';
              unitDropdown.style.marginBottom = '0';
            }
          }
        };
        bind(unitDisplay, 'click', toggleDropdown);

        const hideDropdown = (e) => {
          if (
            !unitDisplay.contains(e.target) &&
            !unitDropdown.contains(e.target)
          ) {
            unitDropdown.style.display = 'none';
          }
        };

        bind(document, 'click', hideDropdown);

        inputRow.appendChild(input);
        inputRow.appendChild(unitDisplay);
        inputRow.appendChild(unitDropdown);
        wrapper.appendChild(label);
        wrapper.appendChild(inputRow);

        return { wrapper, input, unitDisplay };
      };

      const checkboxWrap = document.createElement('div');
      checkboxWrap.style.cssText =
        'display: flex; justify-content: flex-end; align-items: center;';

      const toggleWrap = document.createElement('label');
      toggleWrap.style.cssText =
        'display:flex;  justify-content: center; align-items: center; margin-bottom:0px';
      toggleWrap.innerHTML = `<input type="checkbox" id="applyAll" style="margin-right: 5px;" /><span style="color: black; font-size: 10px;">Apply to all sides</span>`;
      const applyAllCheckbox = toggleWrap.querySelector('#applyAll');

      checkboxWrap.appendChild(toggleWrap);
      mainWrapper.appendChild(checkboxWrap);

      const {
        wrapper: unifiedWrapper,
        input: unifiedInput,
        unitDisplay: unifiedUnit,
      } = createLabeledInput('All Sides', property);
      unifiedWrapper.style.display = 'none';
      wrapper.appendChild(unifiedWrapper);

      const sideInputGrid = document.createElement('div');
      sideInputGrid.style.cssText =
        'display: grid; grid-template-columns: 1fr 1fr; gap: 10px;';

      parts.forEach((side, i) => {
        const {
          wrapper: sideWrapper,
          input,
          unitDisplay,
        } = createLabeledInput(partLabels[i], `${property}-${side}`);
        sideInputs[side] = { input, unitDisplay };
        sideInputGrid.appendChild(sideWrapper);
      });
      wrapper.appendChild(sideInputGrid);

      const clearAllStyles = (component) => {
        const props = parts.map((s) => `${property}-${s}`);
        if (property === 'border-radius') {
          props.forEach((side) =>
            component.removeStyle(`border-${side}-radius`),
          );
        } else {
          component.removeStyle(props);
        }
      };

      const getSelectedComponent = () => editor.getSelected();

      const updateUnified = () => {
        const comp = getSelectedComponent();
        if (!comp) return;
        clearAllStyles(comp);
        const val = parseFloat(unifiedInput.value || 0);
        const style = {};
        parts.forEach((side) => {
          sideInputs[side].input.value = val;
          const unit = unifiedUnit.textContent || 'px';
          const cssProp =
            property === 'border-radius'
              ? `border-${side}-radius`
              : `${property}-${side}`;
          style[cssProp] = `${val}${unit}`;
        });
        comp.addStyle(style);
      };

      const updateSides = () => {
        const comp = getSelectedComponent();
        if (!comp) return;
        clearAllStyles(comp);
        const style = {};
        parts.forEach((side) => {
          const val = parseFloat(sideInputs[side].input.value || 0);
          const unit = sideInputs[side].unitDisplay.textContent || 'px';
          const cssProp =
            property === 'border-radius'
              ? `border-${side}-radius`
              : `${property}-${side}`;
          style[cssProp] = `${val}${unit}`;
        });
        comp.addStyle(style);
      };

      bind(unifiedInput, 'input', updateUnified);
      bind(unifiedInput, 'change', updateUnified);
      bind(unifiedUnit, 'change', updateUnified);

      parts.forEach((side) => {
        const { input, unitDisplay } = sideInputs[side];
        bind(input, 'input', updateSides);
        bind(input, 'change', updateSides);
        bind(unitDisplay, 'change', updateSides);
      });

      bind(applyAllCheckbox, 'change', (e) => {
        const isChecked = e.target.checked;
        unifiedWrapper.style.display = isChecked ? 'block' : 'none';
        sideInputGrid.style.display = isChecked ? 'none' : 'grid';

        if (isChecked) {
          const firstKey = parts[0];
          unifiedInput.value = sideInputs[firstKey].input.value || '';
          unifiedUnit.textContent =
            sideInputs[firstKey].unitDisplay.textContent || 'px';
          updateUnified();
        } else {
          const val = unifiedInput.value || '';
          const unit = unifiedUnit.textContent || 'px';
          parts.forEach((side) => {
            sideInputs[side].input.value = val;
            sideInputs[side].unitDisplay.textContent = unit;
          });
          updateSides();
        }
      });

      wrapper.clear = () => {
        unifiedInput.value = '';
        parts.forEach((side) => (sideInputs[side].input.value = ''));
        applyAllCheckbox.checked ? updateUnified() : updateSides();
      };

      mainWrapper.appendChild(wrapper);

      let clearBtn;
      requestAnimationFrame(() => {
        const traitEl = wrapper.closest('.gjs-sm-property');
        if (!traitEl) return;

        const labelContainer = traitEl.querySelector('.gjs-sm-label');
        clearBtn = traitEl.querySelector('.gjs-sm-clear');

        if (labelContainer && checkboxWrap) {
          // Wrap label and clear icon
          const labelText = labelContainer.querySelector('.gjs-sm-icon');

          const leftGroup = document.createElement('div');
          leftGroup.style.display = 'flex';
          leftGroup.style.alignItems = 'center';
          if (labelText) leftGroup.appendChild(labelText);
          if (clearBtn) leftGroup.appendChild(clearBtn);

          checkboxWrap.style.display = 'flex';
          checkboxWrap.style.alignItems = 'center';

          labelContainer.innerHTML = '';
          labelContainer.style.display = 'flex';
          labelContainer.style.justifyContent = 'space-between';
          labelContainer.style.alignItems = 'center';

          labelContainer.appendChild(leftGroup);
          labelContainer.appendChild(checkboxWrap);
        }

        if (clearBtn) {
          const listener = (e) => {
            e.stopPropagation();
            wrapper.clear();
            toggleClearButtonVisibility();
          };
          bind(clearBtn, 'click', listener);
        }
        toggleClearButtonVisibility();
      });

      // Attach cleanup lifecycle
      mainWrapper.onRemove = () => {
        eventListeners.forEach((off) => off());
        eventListeners.length = 0;
      };

      syncFromComponentStyles();
      toggleClearButtonVisibility();

      // Track the selected component to detect if it changes
      let currentComponent = editor.getSelected();
      const checkAndCleanup = (comp) => {
        if (
          comp === currentComponent &&
          typeof mainWrapper.onRemove === 'function'
        ) {
          mainWrapper.onRemove();
          mainWrapper.onRemove = null; // prevent multiple calls
        }
      };

      editor.on('component:remove', checkAndCleanup);
      eventListeners.push(() =>
        editor.off('component:remove', checkAndCleanup),
      );

      return mainWrapper;

      function toggleClearButtonVisibility() {
        if (!clearBtn) return;
        let show = false;
        if (applyAllCheckbox.checked) {
          if (
            unifiedInput.value.trim() !== '' &&
            parseFloat(unifiedInput.value) !== 0
          ) {
            show = true;
          }
        } else {
          show = parts.some((side) => {
            const val = sideInputs[side].input.value.trim();
            return val !== '' && parseFloat(val) !== 0;
          });
        }
        clearBtn.style.display = show ? '' : 'none';
      }

      function syncFromComponentStyles() {
        //Get Default Values from Selected Comp
        const comp = getSelectedComponent();
        if (!comp || !comp.view || !comp.view.el) return;

        const el = comp.view.el;
        const computed = window.getComputedStyle(el);
        const styleObj = comp.getStyle();

        const values = {};
        parts.forEach((part) => {
          values[part] = { value: '', unit: 'px' };
        });

        const parseValue = (val) => {
          const match = val.trim().match(/^(-?\d+(?:\.\d+)?)([a-z%]+)?$/);
          return match
            ? { value: match[1], unit: match[2] || 'px' }
            : { value: '', unit: 'px' };
        };

        parts.forEach((side) => {
          let cssProp;
          if (property === 'border-radius') {
            const [v, h] = side.split('-');
            cssProp = `border-${v}-${h}-radius`;
          } else {
            cssProp = `${property}-${side}`;
          }

          // getting from inline style (to preserves units like rem/%)
          let rawVal = styleObj[cssProp];
          // Fallback to computed style (converts to px)
          if (!rawVal) {
            rawVal = computed.getPropertyValue(cssProp);
          }
          if (rawVal) {
            values[side] = parseValue(rawVal);
          }
        });

        parts.forEach((side) => {
          if (!sideInputs[side]) return;
          sideInputs[side].input.value = values[side].value;
          sideInputs[side].unitDisplay.textContent = values[side].unit;
        });

        unifiedInput.value = values[parts[0]].value;
        unifiedUnit.textContent = values[parts[0]].unit;
      }
    },
  };
}
